<div class="tabs--nav">
    <p
        *ngFor="let tab of tabs; let index = index"
        (click)="selectTab(tab, index)"
        [class.active]="tab.active"
    >
        {{tab.title}}
    </p>
</div>
<div class="tabs-content">
    <ng-content></ng-content>
</div>

